/* Timbrica — /lightning-map («карта гроз и молний»).
 *
 * ЧТО НА КАРТЕ
 *   Клетки — грозовые очаги: сетка 0,1°, в клетке число вспышек за 5-минутный
 *     кадр. Европа, Африка и запад России приходят так со спутника MTG
 *     (EUMETSAT), обе Америки — с GOES (NOAA), приведённые к тому же виду.
 *   Вспышки — отдельные разряды с временем до секунды. Над Америками (GOES)
 *     файл выходит раз в 20 секунд, и вспышки показываются с постоянной
 *     задержкой, чтобы на карте шёл ровный поток, а не залпы. Над Европой и
 *     Африкой (MTG) вспышки приходят пачкой раз в 10 минут уже «в возрасте»
 *     от 1 до 11 минут — их показываем сразу: придержать значило бы спрятать
 *     от человека то, что уже известно.
 *
 * ГЛАВНОЕ ПРАВИЛО. Карта не говорит «гроз нет» там, где она не знает: вне
 * покрытия спутников и при устаревших данных ответ — «не знаем», и прежний
 * ответ со страницы снимается (тот же урок, что у /space-weather).
 *
 * Формат кусков — App\Services\Lightning\LightningStore (обе стороны правятся
 * вместе): «TLG1», длина JSON, JSON, двоичные блоки.
 */
(function () {
  'use strict';
  var C = window.LIGHTNING_CFG || {};
  var T = C.t || {}, API = C.api || {};
  var SLUG = 'lightning-map';
  var $ = function (id) { return document.getElementById(id); };
  var tr = function (k, vars) {
    var s = T[k] != null ? String(T[k]) : k;
    if (vars) for (var v in vars) s = s.split(':' + v).join(vars[v]);
    return s;
  };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (name) { try { window.__stage && window.__stage(name); } catch (e) {} };

  /* ── Постоянные ──────────────────────────────────────────────────────── */
  var SOUND_KMS = 0.343;      // скорость звука, км/с
  var STALE = { ge: 240, gw: 240, li: 1500, lf: 1500 };   // секунд без приёма — «не обновляется»
  /* Отдельные вспышки по регионам: сколько вспышка живёт точкой (win), с какой
     задержкой показывается (replay) и как часто спрашиваем сервер (every). */
  var LIVE = {
    am: { win: 600, replay: 75, every: 10000 },
    eu: { win: 900, replay: 0, every: 30000 }
  };

  /* Где чьи данные. У MTG зона — круг от подспутниковой точки (0°, 0°) в
     пределах отдаваемого слоя. Замер на 71 кадре за 2026 год: вспышки приходят
     до самого края диска (81°), но дальше ~62° спутник видит их под острым
     углом — пропускает больше и размазывает на десятки километров. Поэтому
     «данные есть» — до 78°, а от 62° страница говорит «вы у края обзора»
     (Москва — 63,5°, Екатеринбург — 74°). */
  var COVER = {
    am: { latMax: 52, lonW: 168, lonE: -30 },                 // GOES-West + GOES-East (через линию дат)
    eu: { lonW: -30, lonE: 70, latMax: 70, reach: 78, edge: 62 }
  };

  /* Возраст → цвет. Две палитры: на светлой подложке жёлтое и белое не видны,
     там свежее — самое тёмное и насыщенное (каждый цвет держит контраст 3:1 к
     суше светлой карты, сторож MapBasemapBrightnessTest). Полоску легенды
     красит paintLegend() из этих же строк — разойтись им негде. */
  var RAMP_STOPS = [0, 0.07, 0.25, 0.55, 1];
  var RAMP_HEX = {
    dark:  ['#ffffff', '#fff47a', '#ffb02e', '#ff5a3c', '#9646c8'],
    light: ['#c8005a', '#d6142d', '#c45400', '#8a6400', '#6e6480']
  };
  var RAMP = {};
  ['dark', 'light'].forEach(function (name) {
    RAMP[name] = RAMP_HEX[name].map(function (hex, i) {
      var n = parseInt(hex.slice(1), 16);
      return [RAMP_STOPS[i], (n >> 16) & 255, (n >> 8) & 255, n & 255];
    });
  });
  var skinName = 'dark';

  /* ── Состояние ───────────────────────────────────────────────────────── */
  var map = null, glc = null, gl = null, prog = null, fx = null, loc = {};
  /* Слой молний — два холста в панели карты, как у собственных слоёв Leaflet:
     холст шире окна на PAD с каждой стороны и стоит в координатах слоя. Пока
     карту тянут, он едет вместе с подложкой сам (его двигает панель карты, а не
     перерисовка), при зуме масштабируется тем же преобразованием, что и
     подложка, а перерисовывается, когда жест кончился или окно вышло за запас.
     Прежняя схема — холст, приколотый к окну и перерисовка на каждое событие
     движения — давала рывки (сто тысяч точек на кадр) и не участвовала в
     анимации зума: подложка плавно росла, а молнии десять кадров стояли. */
  var PAD = 0.2;
  var drawn = null;            // чему соответствует нарисованное: {min, w, h, zoom, center, org}
  var gesture = { moving: false, zooming: false, at: 0 };
  var clockOffset = 0, clockSynced = false;                   // сервер − браузер, с
  var statusData = null, statusAt = 0, statusFailed = 0;
  var tRef = Math.floor(Date.now() / 1000) - 100000;          // начало отсчёта для float32
  var regions = {
    am: { want: false, win: null, blocks: [], latest: {}, buf: null, n: 0, loading: false, meta: null },
    eu: { want: false, win: null, blocks: [], latest: {}, buf: null, n: 0, loading: false, meta: null }
  };
  function mkLive() { return { after: 0, slots: {}, order: [], buf: null, n: 0, list: [], pts: null, dirty: true, timer: null, shownTo: 0, fresh: [] }; }
  var live = { am: mkLive(), eu: mkLive() };
  var motion = null;                                          // движение грозы у «моей» точки — для стрелки на карте
  var watches = [];                                           // точки слежки (lightning-watch.js) — круги на карте
  var view = { win: '1h', scrub: null, playing: false, cover: false, sound: false };
  var me = null;                                              // {lat, lon, kind:'geo'|'pick'}
  var meMarker = null, pulses = [], raf = null, hotSeq = 0, audio = null, lastThunder = 0;
  var timerRun = null, timerRingKm = null;
  var lastSaid = '';
  var geoIssue = null;                                        // почему «Рядом со мной» не сработало (__geo.explain)
  var wx = null;                                              // прогноз погоды для точки: {key, temp, rainIn}

  function now() { return Date.now() / 1000 + clockOffset; }
  function viewNow() { return view.scrub != null ? view.scrub : now(); }
  function winSec() { return view.win === '24h' ? 86400 : 3600; }

  /* ── Проекция ────────────────────────────────────────────────────────── */
  function mercX(lon) { return (lon + 180) / 360; }
  function mercY(lat) {
    var l = Math.max(-85, Math.min(85, lat)) * Math.PI / 180;
    return 0.5 - Math.log(Math.tan(Math.PI / 4 + l / 2)) / (2 * Math.PI);
  }
  function kmBetween(lat1, lon1, lat2, lon2) {
    var p = Math.PI / 180, dLat = (lat2 - lat1) * p, dLon = (lon2 - lon1) * p;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * p) * Math.cos(lat2 * p) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 12742 * Math.asin(Math.min(1, Math.sqrt(a)));
  }
  function bearing8(lat1, lon1, lat2, lon2) {
    var p = Math.PI / 180, y = Math.sin((lon2 - lon1) * p) * Math.cos(lat2 * p);
    var x = Math.cos(lat1 * p) * Math.sin(lat2 * p) - Math.sin(lat1 * p) * Math.cos(lat2 * p) * Math.cos((lon2 - lon1) * p);
    return Math.round(((Math.atan2(y, x) / p + 360) % 360) / 45) % 8;
  }
  function normLon(lon) { return ((lon + 180) % 360 + 360) % 360 - 180; }

  /* Центральный угол от подспутниковой точки MTG (0°, 0°), градусы. */
  function mtgAngle(lat, lon) {
    return Math.acos(Math.cos(lat * Math.PI / 180) * Math.cos(normLon(lon) * Math.PI / 180)) * 180 / Math.PI;
  }
  /* Точка у края обзора MTG: данные есть, но грубые. */
  function edgeAt(lat, lon) {
    return coverageAt(lat, lon) === 'eu' && mtgAngle(lat, lon) > COVER.eu.edge;
  }

  /* Кто видит эту точку: 'am', 'eu' или null — вне открытых спутников. */
  function coverageAt(lat, lon) {
    lon = normLon(lon);
    var a = COVER.am, e = COVER.eu;
    if (lon >= e.lonW && lon <= e.lonE && Math.abs(lat) <= e.latMax) {
      if (mtgAngle(lat, lon) <= e.reach) return 'eu';
    }
    if (Math.abs(lat) <= a.latMax && (lon < a.lonE || lon >= a.lonW)) return 'am';
    return null;
  }

  /* ── Разбор кусков ───────────────────────────────────────────────────── */
  function parsePayload(buf) {
    var dv = new DataView(buf);
    if (buf.byteLength < 8 || dv.getUint32(0, false) !== 0x544C4731) throw new Error('bad payload');   // «TLG1»
    var jl = dv.getUint32(4, true);
    var meta = JSON.parse(new TextDecoder('utf-8').decode(new Uint8Array(buf, 8, jl)));
    return { meta: meta, dv: dv, buf: buf, off: 8 + jl };
  }

  function parseCells(p) {
    var blocks = [], off = p.off, dv = p.dv, end = p.buf.byteLength;
    while (off + 16 <= end) {
      var src = dv.getUint8(off), n = dv.getUint32(off + 4, true), latest = dv.getUint32(off + 8, true);
      off += 16;
      var need = n * 9 + ((4 - n % 4) % 4);
      if (off + need > end) break;
      blocks.push({
        src: src, n: n, latest: latest,
        keys: new Uint32Array(p.buf.slice(off, off + n * 4)),
        masks: new Uint32Array(p.buf.slice(off + n * 4, off + n * 8)),
        counts: new Uint8Array(p.buf.slice(off + n * 8, off + n * 9))
      });
      off += need;
    }
    return blocks;
  }

  /* Клетки региона → точки для отрисовки: по точке на каждый шаг, в котором
     клетка светилась; от старых к свежим, чтобы свежее ложилось сверху. */
  function buildRegion(r) {
    var meta = r.meta || {}, step = meta.step || 300, steps = meta.steps || 12, grid = meta.grid || 0.1;
    var total = 0, b, i, a;
    for (b = 0; b < r.blocks.length; b++) {
      var m = r.blocks[b].masks;
      for (i = 0; i < m.length; i++) { var v = m[i]; while (v) { total++; v &= v - 1; } }
    }
    var arr = new Float32Array(total * 4), o = 0;
    var perRow = grid === 0.2 ? 1800 : 3600;
    for (a = steps - 1; a >= 0; a--) {
      var bit = (1 << a) >>> 0;
      for (b = 0; b < r.blocks.length; b++) {
        var blk = r.blocks[b];
        // момент шага — его середина: вспышки кадра случились где-то внутри
        var t = (blk.latest - a) * step + step / 2 - tRef;
        for (i = 0; i < blk.n; i++) {
          if (!(blk.masks[i] & bit)) continue;
          var key = blk.keys[i], row = Math.floor(key / perRow), col = key % perRow;
          var lat = row * grid - 90 + grid / 2, lon = col * grid - 180 + grid / 2;
          arr[o++] = mercX(lon); arr[o++] = mercY(lat); arr[o++] = t;
          arr[o++] = Math.min(1, blk.counts[i] / (grid === 0.2 ? 60 : 14));
        }
      }
    }
    r.pts = arr; r.n = total; r.dirty = true;
    indexRegion(r);
  }

  /* ── Указатель клеток: «что рядом с точкой» без обхода всего региона ─────
   * Расстояние до грозы и её курс считаются по клеткам в сотне километров от
   * точки, а регион — это до сотни тысяч клеток на двенадцать кадров. Обход
   * всех на каждое нажатие по карте стоил телефону сотен миллисекунд: замер
   * 14.10.2026 (профиль телефона, процессор ×4) — первое нажатие 688 мс, из
   * них 364 в обработчике; в телеметрии «медленных нажатий» по карте — 61 за
   * неделю, в среднем 275–606 мс. Клетки раскладываются по градусным ведрам
   * один раз, при приходе кадра; запрос берёт только ведра вокруг точки. */
  function indexRegion(r) {
    var meta = r.meta || {}, grid = meta.grid || 0.1, perRow = grid === 0.2 ? 1800 : 3600, idx = {};
    for (var k = 0; k < r.blocks.length; k++) {
      var blk = r.blocks[k];
      for (var i = 0; i < blk.n; i++) {
        var key = blk.keys[i];
        var bk = Math.floor(Math.floor(key / perRow) * grid) * 360 + Math.floor((key % perRow) * grid);
        (idx[bk] || (idx[bk] = [])).push(k, i);
      }
    }
    r.idx = idx;
    return r;
  }
  /* Клетки не дальше dLat градусов широты и dLon градусов долготы от точки:
     fn(блок, номер клетки, широта, долгота). Дальние ведра не открываются;
     сама проверка расстояния остаётся за вызывающим. */
  function eachCellNear(r, lat0, lon0, dLat, dLon, fn) {
    var meta = r.meta || {}, grid = meta.grid || 0.1, perRow = grid === 0.2 ? 1800 : 3600;
    var idx = r.idx || indexRegion(r).idx;
    var rowLo = Math.max(0, Math.floor(lat0 - dLat + 90)), rowHi = Math.min(179, Math.floor(lat0 + dLat + 90));
    var colLo = Math.floor(lon0 - dLon + 180), colHi = Math.floor(lon0 + dLon + 180);
    if (colHi - colLo >= 359) { colLo = 0; colHi = 359; }
    for (var row = rowLo; row <= rowHi; row++) {
      for (var c = colLo; c <= colHi; c++) {
        var list = idx[row * 360 + ((c % 360) + 360) % 360];
        if (!list) continue;
        for (var j = 0; j < list.length; j += 2) {
          var blk = r.blocks[list[j]], i = list[j + 1], key = blk.keys[i];
          fn(blk, i, Math.floor(key / perRow) * grid - 90 + grid / 2, (key % perRow) * grid - 180 + grid / 2);
        }
      }
    }
  }

  /* ── Загрузка ────────────────────────────────────────────────────────── */
  /* Запрос со сроком. Без него зависшее соединение не кончалось ничем: ни
     данных, ни отказа — и страница вечно «спрашивала спутники». */
  function fetchTimed(url, ms) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    // Срок общий — на ответ вместе с телом; у завершённого запроса он ничего не
    // делает. Считается по ВИДИМОМУ времени: вкладку, открытую в фоне, телефон
    // замораживает — ответ уже пришёл, а страница его ещё не прочла, и срок по
    // стенным часам обрывал его в миг возвращения («клетки не загрузились» при
    // ответе 200 на оба региона, 13.10.2026).
    var arm = typeof window.__visibleTimeout === 'function' ? window.__visibleTimeout : setTimeout;
    if (ctl) arm(function () { ctl.abort(); }, ms || 20000);
    return fetch(url, { credentials: 'omit', signal: ctl ? ctl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r;
    });
  }
  function fetchBin(url) {
    return fetchTimed(url, 25000).then(function (r) { return r.arrayBuffer(); }).then(parsePayload);
  }
  function errText(err) {
    return String(err && err.name ? err.name + ': ' + err.message : err).slice(0, 120);
  }

  function loadRegion(name, force) {
    var r = regions[name];
    if (r.loading || (!force && r.win === view.win)) return;
    r.loading = true; r.fetchedAt = Date.now();
    var win = view.win;
    fetchBin(API.cells + '?r=' + name + '&w=' + win).then(function (p) {
      r.loading = false;
      if (win !== view.win) { loadRegion(name, true); return null; }   // окно сменили, пока шёл запрос
      r.meta = p.meta; r.blocks = parseCells(p); r.win = win; r.latest = {}; r.failed = 0;
      for (var k in (p.meta.blocks || {})) r.latest[k] = p.meta.blocks[k].latest;
      buildRegion(r);
      return p.meta;
    }).then(function (meta) {
      // Вне ветки отказа: ошибка в отрисовке — не «клетки не загрузились», и
      // повторять из-за неё запрос незачем.
      if (meta) afterData(meta);
    }, function (err) {
      r.loading = false; r.failed = (r.failed || 0) + 1;
      if (r.failed === 1) ae('tool_error', { slug: SLUG, where: 'cells_' + name, msg: errText(err) });
      // Неудачная загрузка не должна оставлять регион с клетками прошлого
      // окна (или вовсе без них) до перезагрузки страницы: повторяем сами,
      // всё реже, а после второго отказа говорим об этом в строке состояния.
      setTimeout(function () { if (r.want && r.win !== view.win) loadRegion(name, true); }, Math.min(30000, 3000 * r.failed));
      renderStatus(); renderMe();
    });
  }

  /* Блоки «живых» вспышек: слот → список. Время вспышки = конец слота минус
     её возраст в секундах; координаты — int16 (широта ×360, долгота ×180). */
  function parseLive(p) {
    var dv = p.dv, off = p.off, end = p.buf.byteLength, slotSec = p.meta.slotSec || 10, out = [];
    while (off + 8 <= end) {
      var slot = dv.getUint32(off, true), n = dv.getUint32(off + 4, true);
      off += 8;
      if (off + n * 8 > end) break;
      var base = (slot + 1) * slotSec, list = [];
      for (var i = 0; i < n; i++, off += 8) {
        var info = dv.getUint8(off + 7);
        list.push({
          lat: dv.getInt16(off, true) / 360, lon: dv.getInt16(off + 2, true) / 180,
          t: base - dv.getUint16(off + 4, true), w: dv.getUint8(off + 6) / 255, r: (info & 31) * 2, src: info >> 5
        });
      }
      out.push({ slot: slot, list: list });
    }
    return out;
  }

  function loadLive(name) {
    var lv = live[name], cfg = LIVE[name];
    if (!regions[name].want || document.hidden) return;
    fetchBin(API.live + '?r=' + name + '&after=' + lv.after).then(function (p) {
      syncClock(p.meta);
      var slots = parseLive(p), slotSec = p.meta.slotSec || 10, first = lv.order.length === 0;
      slots.forEach(function (sl) {
        if (!lv.slots[sl.slot]) {
          lv.order.push(sl.slot);
          // пачка, которой ещё не было, — её вспышки «вспыхнут» на карте
          if (!first && cfg.replay === 0) lv.fresh = lv.fresh.concat(sl.list);
        }
        lv.slots[sl.slot] = sl.list;
        // текущий слот ещё дописывается — следующий запрос возьмёт его снова
        if (sl.slot < p.meta.slot && sl.slot > lv.after) lv.after = sl.slot;
      });
      // Слот — момент приёма, вспышки в нём старше: слот старше окна целиком не нужен.
      var floor = Math.floor((now() - cfg.win - cfg.replay) / slotSec);
      lv.order = lv.order.filter(function (sl) { if (sl < floor) { delete lv.slots[sl]; return false; } return true; });
      if (slots.length) { rebuildLive(name); schedule(); renderStatus(); if (me) renderMe(); scheduleHot(); }
    }).catch(function () { /* следующий такт повторит */ });
  }

  function rebuildLive(name) {
    var lv = live[name], cfg = LIVE[name], list = [], oldest = now() - cfg.win - cfg.replay;
    for (var i = 0; i < lv.order.length; i++) {
      var sl = lv.slots[lv.order[i]] || [];
      for (var k = 0; k < sl.length; k++) if (sl[k].t >= oldest) list.push(sl[k]);
    }
    list.sort(function (a, b) { return a.t - b.t; });
    lv.list = list;
    var arr = new Float32Array(list.length * 4);
    for (var j = 0; j < list.length; j++) {
      var f = list[j];
      arr[j * 4] = mercX(f.lon); arr[j * 4 + 1] = mercY(f.lat); arr[j * 4 + 2] = f.t - tRef; arr[j * 4 + 3] = f.w;
    }
    lv.pts = arr; lv.n = list.length; lv.dirty = true;
  }

  /* Ответ мог полежать в кэше (до 10–20 с), и его `now` тогда отстаёт. Ближе
     всех к правде самый «поздний» из увиденных — на нём и держимся. */
  function syncClock(meta) {
    if (!meta || !meta.now) return;
    var off = meta.now - Date.now() / 1000;
    if (!clockSynced || off > clockOffset) { clockOffset = off; clockSynced = true; }
  }

  function loadStatus() {
    if (document.hidden) return;
    fetchTimed(API.status, 15000).then(function (r) { return r.json(); }).then(function (s) {
      syncClock(s); statusData = s; statusAt = Date.now(); statusFailed = 0;
      // У региона вышел новый кадр — забираем клетки заново. Не чаще раза в
      // 45 с (сутки — раз в 5 минут): кусок на сервере пересобирается не
      // мгновенно, и без паузы страница качала бы прежний по кругу.
      ['am', 'eu'].forEach(function (name) {
        var r = regions[name]; if (!r.want || r.loading || r.win !== view.win) return;
        if (Date.now() - (r.fetchedAt || 0) < (view.win === '24h' ? 300000 : 45000)) return;
        var srcs = name === 'am' ? ['ge', 'gw'] : ['li'], step = view.win === '24h' ? 12 : 1;
        for (var i = 0; i < srcs.length; i++) {
          var fresh = Math.floor(((s.sources[srcs[i]] || {}).frame || 0) / step);
          if (fresh && (r.latest[srcs[i]] == null || fresh > r.latest[srcs[i]])) { loadRegion(name, true); break; }
        }
      });
      renderStatus(); renderMe();
    }).catch(function () {
      statusFailed++;
      renderStatus(); renderMe();
    });
  }

  function sourceStale(src) {
    if (!statusData) return true;
    var s = statusData.sources[src] || {};
    return !s.seen || now() - s.seen > STALE[src];
  }
  function regionStale(name) {
    if (name === 'am') return sourceStale('ge') && sourceStale('gw');
    return sourceStale('li') && sourceStale('lf');
  }
  function regionDataTime(name) {
    if (!statusData) return 0;
    var s = statusData.sources;
    if (name === 'am') return Math.max((s.ge || {}).data || 0, (s.gw || {}).data || 0);
    return Math.max((s.li || {}).data || 0, (s.lf || {}).data || 0);
  }
  /* У Европы два вида данных: кадр клеток и пачка отдельных вспышек. Строка
     состояния называет тот, что свежее. */
  function euShowsFlashes() {
    if (!statusData) return false;
    var s = statusData.sources;
    return !sourceStale('lf') && ((s.lf || {}).data || 0) >= ((s.li || {}).data || 0);
  }

  /* ── Карта и холсты ──────────────────────────────────────────────────── */
  function initMap() {
    if (!window.L || !$('lmMap')) return false;
    var tile = C.tile || {}, home = C.home || { lat: 20, lon: 10, z: 2 };
    map = L.map('lmMap', { center: [home.lat, home.lon], zoom: home.z, minZoom: 2, maxZoom: 11, worldCopyJump: true, zoomSnap: 0.5 });
    if (window.__mapTiles) {
      window.__mapTiles.base(L, map, null, {
        slug: SLUG, credit: tr('map_attr'), opts: { maxZoom: 19 }, text: tile.offline,
        styles: tile.styles, labels: tile.labels,
        onStyle: function (mode) {
          skinName = RAMP[mode] ? mode : 'dark';
          var st = $('lmStage'); if (st) st.setAttribute('data-basemap', skinName);
          paintLegend(); schedule();
        }
      });
    } else if (window.__basemapFallback) {
      window.__basemapFallback(L, map, tr('map_attr'));
    }
    var pane = map.getPanes().overlayPane;
    glc = document.createElement('canvas'); glc.className = 'lm-canvas';
    fx = document.createElement('canvas'); fx.className = 'lm-canvas';
    pane.appendChild(glc); pane.appendChild(fx);
    initGL();
    [glc, fx].forEach(function (cv) { L.DomUtil.addClass(cv, 'leaflet-zoom-animated'); });
    map.on('movestart', function () { gesture.moving = true; gesture.at = performance.now(); });
    map.on('zoomstart', function () { gesture.zooming = true; gesture.at = performance.now(); });
    map.on('move', function () { gesture.at = performance.now(); if (!covered()) schedule(); });
    map.on('zoomanim', function (e) { gesture.at = performance.now(); transformTo(e.center, e.zoom); });
    map.on('zoom', function () { gesture.at = performance.now(); transformTo(map.getCenter(), map.getZoom()); });
    map.on('moveend', function () { gesture.moving = false; schedule(); });
    map.on('zoomend', function () { gesture.zooming = false; schedule(); });
    map.on('resize viewreset', schedule);
    // Сцена меняет размер не только вместе с окном: консоль перекладывается по
    // СВОЕЙ ширине (сайдбар свернули, широкий режим, «на весь экран»), а Leaflet
    // слушает только resize окна — карта оставалась бы нарисованной в прежнем
    // боксе, с пустой полосой там, куда сцена выросла.
    if (window.ResizeObserver) {
      var roRaf = 0;
      new ResizeObserver(function () {
        if (roRaf) return;
        roRaf = requestAnimationFrame(function () { roRaf = 0; map.invalidateSize({ debounceMoveend: true }); });
      }).observe($('lmMap'));
    }
    map.on('moveend', onView);
    map.on('click', function (ev) { setMe(ev.latlng.lat, normLon(ev.latlng.lng), 'pick'); });
    return true;
  }

  var VS = 'precision highp float;attribute vec4 a;uniform vec2 u_org,u_res;uniform float u_scale,u_dpr,u_now,u_win,u_size,u_min,u_wx;uniform mediump float u_kind;' +
    'varying float v_age;varying float v_w;void main(){float age=u_now-a.z;' +
    'if(age<0.0||age>u_win){gl_Position=vec4(2.0,2.0,2.0,1.0);gl_PointSize=0.0;return;}' +
    'vec2 px=vec2((a.x+u_wx)*u_scale,a.y*u_scale)-u_org;' +
    'gl_Position=vec4(px.x/u_res.x*2.0-1.0,1.0-px.y/u_res.y*2.0,0.0,1.0);float s=u_size;' +
    'if(u_kind<0.5){float yy=3.14159265*(1.0-2.0*a.y);s=u_size*0.5*(exp(yy)+exp(-yy));}else{s=u_size*(0.55+0.75*a.w);}' +
    'gl_PointSize=max(u_min,s)*u_dpr;v_age=age/u_win;v_w=a.w;}';
  var FS = 'precision mediump float;varying float v_age;varying float v_w;uniform mediump float u_kind;uniform vec4 u_c0,u_c1,u_c2,u_c3,u_c4;uniform vec4 u_stops;' +
    'vec3 ramp(float t){if(t<u_stops.x)return mix(u_c0.rgb,u_c1.rgb,t/u_stops.x);' +
    'if(t<u_stops.y)return mix(u_c1.rgb,u_c2.rgb,(t-u_stops.x)/(u_stops.y-u_stops.x));' +
    'if(t<u_stops.z)return mix(u_c2.rgb,u_c3.rgb,(t-u_stops.y)/(u_stops.z-u_stops.y));' +
    'return mix(u_c3.rgb,u_c4.rgb,(t-u_stops.z)/(1.0-u_stops.z));}' +
    'void main(){vec2 c=gl_PointCoord-0.5;float al;' +
    'if(u_kind<0.5){float d2=dot(c,c)*4.0;al=exp(-3.2*d2)*(0.3+0.5*v_w);if(d2>1.0)al=0.0;}' +
    'else{float d=length(c)*2.0;al=smoothstep(1.0,0.15,d);}' +
    'float fade=mix(1.0,0.4,v_age);gl_FragColor=vec4(ramp(v_age),1.0)*(al*fade);}';

  /* WebGL отказал — рисуем на 2D-холсте. Причина уходит в телеметрию: иначе о
     сломанном быстром пути никто не узнает. Холст WebGL прячется: на нём
     могло остаться нарисованное до отказа. */
  function glFail(why) {
    try { window.__aeDiagnostic && window.__aeDiagnostic({ issue: 'lightning_webgl_init', detail: String(why).slice(0, 200) }); } catch (e) {}
    gl = null;
    if (glc) glc.style.visibility = 'hidden';
  }

  var glWired = false;
  function initGL() {
    try {
      gl = glc.getContext('webgl', { antialias: false, premultipliedAlpha: true, alpha: true }) || glc.getContext('experimental-webgl');
    } catch (e) { gl = null; }
    if (!gl) return;
    // Целиком под try: браузер с заглушкой вместо WebGL (защита от отпечатков,
    // расширение) отдаёт «контекст», у которого нет половины методов, —
    // «createShader is not a function» роняло страницу ещё до карты (10.10.2026).
    try {
      var shErr = '';
      var sh = function (type, src) {
        var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
        if (gl.getShaderParameter(s, gl.COMPILE_STATUS)) return s;
        shErr = gl.getShaderInfoLog(s); return null;
      };
      var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
      if (!vs || !fs) { glFail('compile: ' + shErr); return; }
      prog = gl.createProgram();
      gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { glFail('link: ' + gl.getProgramInfoLog(prog)); return; }
      gl.useProgram(prog);
      ['u_org', 'u_res', 'u_scale', 'u_dpr', 'u_now', 'u_win', 'u_size', 'u_min', 'u_kind', 'u_wx', 'u_c0', 'u_c1', 'u_c2', 'u_c3', 'u_c4', 'u_stops']
        .forEach(function (n) { loc[n] = gl.getUniformLocation(prog, n); });
      loc.a = gl.getAttribLocation(prog, 'a');
      gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    } catch (e) { glFail('exception: ' + (e && e.message)); return; }
    glc.style.visibility = '';
    if (glWired) return;
    glWired = true;
    glc.addEventListener('webglcontextlost', function (e) { e.preventDefault(); });
    glc.addEventListener('webglcontextrestored', function () {
      regions.am.buf = regions.eu.buf = live.am.buf = live.eu.buf = null; regions.am.dirty = regions.eu.dirty = live.am.dirty = live.eu.dirty = true;
      initGL(); schedule();
    });
  }

  function upload(holder) {
    if (!holder.pts) return;
    if (!holder.buf) holder.buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, holder.buf);
    gl.bufferData(gl.ARRAY_BUFFER, holder.pts, gl.DYNAMIC_DRAW);
    holder.dirty = false;
  }

  function schedule() { if (!raf) raf = requestAnimationFrame(frame); }

  /* Идёт ли жест: карту тянут, она доезжает по инерции, анимируется зум.
     Флаг живёт 400 мс после последнего события: человек, который держит
     карту и не двигает её, перерисовке не мешает — и потерянное «конец
     движения» не оставит слой навсегда замершим. */
  function busy() {
    return (gesture.moving || gesture.zooming) && performance.now() - gesture.at < 400;
  }

  /* Закрывает ли нарисованное окно карты прямо сейчас. */
  function covered() {
    if (!drawn) return false;
    if (gesture.zooming) return true;                     // масштаб ведёт transformTo()
    if (drawn.zoom !== map.getZoom()) return false;
    var tl = map.containerPointToLayerPoint([0, 0]), sz = map.getSize();
    return tl.x >= drawn.min.x && tl.y >= drawn.min.y && tl.x + sz.x <= drawn.min.x + drawn.w && tl.y + sz.y <= drawn.min.y + drawn.h;
  }

  /* Зум: холсты получают то же преобразование, что слои самой Leaflet
     (L.Renderer._updateTransform), — нарисованное растёт вместе с подложкой. */
  function transformTo(center, zoom) {
    if (!drawn || !map._getNewPixelOrigin) return;
    var scale = map.getZoomScale(zoom, drawn.zoom);
    var half = L.point(drawn.w / 2, drawn.h / 2);
    var offset = half.multiplyBy(-scale).add(map.project(drawn.center, zoom)).subtract(map._getNewPixelOrigin(center, zoom));
    [glc, fx].forEach(function (cv) { L.DomUtil.setTransform(cv, offset, scale); });
    // Слишком сильно растянутая картинка (долгий перелёт, щипок на три зума) —
    // пора нарисовать заново, не дожидаясь конца жеста.
    if ((scale > 3 || scale < 0.4) && !map._animatingZoom) { gesture.at = 0; schedule(); }
  }

  /* Поставить холсты под текущий вид: окно плюс запас PAD с каждой стороны. */
  function anchor() {
    var size = map.getSize(), dpr = Math.min(2, window.devicePixelRatio || 1);
    var padX = Math.round(size.x * PAD), padY = Math.round(size.y * PAD);
    var min = map.containerPointToLayerPoint([-padX, -padY]).round();
    var w = size.x + 2 * padX, h = size.y + 2 * padY;
    [glc, fx].forEach(function (cv) {
      if (cv.width !== Math.round(w * dpr) || cv.height !== Math.round(h * dpr)) {
        cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
        cv.style.width = w + 'px'; cv.style.height = h + 'px';
      }
      L.DomUtil.setPosition(cv, min);
    });
    // org — мировые пиксели левого верхнего угла холста: точка слоя + начало слоя
    drawn = { min: min, w: w, h: h, dpr: dpr, zoom: map.getZoom(), center: map.layerPointToLatLng(min.add([w / 2, h / 2])), org: map.getPixelOrigin().add(min) };
  }

  /* Точка на холсте (CSS-пиксели) для широты и долготы. */
  function toCanvas(ll) {
    var q = map.project(ll, drawn.zoom);
    return { x: q.x - drawn.org.x, y: q.y - drawn.org.y };
  }
  function frameBounds() {
    return L.latLngBounds(map.unproject(drawn.org, drawn.zoom), map.unproject(drawn.org.add([drawn.w, drawn.h]), drawn.zoom));
  }

  function frame() {
    raf = null;
    if (!map) return;
    // Жест идёт, а нарисованное всё ещё закрывает окно — холст едет с картой
    // сам; перерисуем по концу жеста (moveend / zoomend зовут schedule).
    if (busy() && covered()) return;
    if (view.playing) stepPlayback();
    draw();
    // Кадры идут, только пока что-то движется: вспышки, кольца, проигрывание.
    if (view.playing || pulses.length || (timerRun && me)) schedule();
  }

  function draw() {
    anchor();
    var size = { x: drawn.w, y: drawn.h }, dpr = drawn.dpr, z = drawn.zoom;
    var scale = 256 * Math.pow(2, z), org = drawn.org, tNow = viewNow() - tRef;
    var ctx = fx.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, size.x, size.y);
    if (view.cover) drawCoverage(ctx, size);

    var grid = view.win === '24h' ? 0.2 : 0.1, cellPx = scale * grid / 360;
    // Точка WebGL не бывает больше ~64 px на слабых видеочипах, а клетка в
    // меркаторе у 60-й широты вдвое выше экваториальной — крупные рисует 2D-холст.
    var useGL = !!gl && cellPx * 2.6 * 2.2 < 60;
    if (gl) try {
      gl.viewport(0, 0, glc.width, glc.height);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      var ramp = RAMP[skinName];
      for (var i = 0; i < 5; i++) gl.uniform4f(loc['u_c' + i], ramp[i][1] / 255, ramp[i][2] / 255, ramp[i][3] / 255, 1);
      gl.uniform4f(loc.u_stops, ramp[1][0], ramp[2][0], ramp[3][0], 1);
      gl.uniform2f(loc.u_org, org.x, org.y); gl.uniform2f(loc.u_res, size.x, size.y);
      gl.uniform1f(loc.u_scale, scale); gl.uniform1f(loc.u_dpr, dpr);
      if (useGL) {
        gl.uniform1f(loc.u_kind, 0); gl.uniform1f(loc.u_now, tNow); gl.uniform1f(loc.u_win, winSec());
        gl.uniform1f(loc.u_size, cellPx * 2.6); gl.uniform1f(loc.u_min, z < 4 ? 2.6 : 3.6);
        drawHolder(regions.eu); drawHolder(regions.am);
      }
      if (view.win === '1h') ['eu', 'am'].forEach(function (name) {
        var lv = live[name], cfg = LIVE[name];
        if (!lv.n) return;
        gl.uniform1f(loc.u_kind, 1); gl.uniform1f(loc.u_now, tNow - (view.scrub != null ? 0 : cfg.replay));
        gl.uniform1f(loc.u_win, cfg.win); gl.uniform1f(loc.u_size, z < 4 ? 5 : (z < 6 ? 8 : 11)); gl.uniform1f(loc.u_min, 3);
        drawHolder(lv);
      });
    } catch (e) {
      // тот же отказ, но уже в кадре: этот и следующие кадры рисует 2D-путь
      glFail('draw: ' + (e && e.message)); useGL = false;
    }
    if (!useGL) drawCells2D(ctx, size);
    if (!gl && view.win === '1h') drawFlashes2D(ctx, size);
    drawFx(ctx, size, z);
  }

  function drawHolder(h) {
    if (!h.n || !h.pts) return;
    if (h.dirty || !h.buf) upload(h);
    gl.bindBuffer(gl.ARRAY_BUFFER, h.buf);
    gl.enableVertexAttribArray(loc.a);
    gl.vertexAttribPointer(loc.a, 4, gl.FLOAT, false, 0, 0);
    for (var wx = -1; wx <= 1; wx++) { gl.uniform1f(loc.u_wx, wx); gl.drawArrays(gl.POINTS, 0, h.n); }
  }

  function rampCss(t, alpha) {
    var r = RAMP[skinName], i = 1;
    while (i < r.length - 1 && t > r[i][0]) i++;
    var a = r[i - 1], b = r[i], k = Math.max(0, Math.min(1, (t - a[0]) / ((b[0] - a[0]) || 1)));
    return 'rgba(' + Math.round(a[1] + (b[1] - a[1]) * k) + ',' + Math.round(a[2] + (b[2] - a[2]) * k) + ',' + Math.round(a[3] + (b[3] - a[3]) * k) + ',' + alpha + ')';
  }

  /* Клетки на 2D-холсте: крупный масштаб (их в кадре сотни) и браузер без
     WebGL (тогда — только свежий шаг каждой клетки и не больше 30 тысяч). */
  function drawCells2D(ctx, size) {
    var pad = 0.2, b = frameBounds(), south = b.getSouth() - pad, north = b.getNorth() + pad, west = b.getWest() - pad, east = b.getEast() + pad;
    var tNow = viewNow(), win = winSec(), drawn = 0, wide = east - west >= 360;
    ['eu', 'am'].forEach(function (name) {
      var r = regions[name], meta = r.meta || {}, step = meta.step || 300, steps = meta.steps || 12;
      // сетка — та, в которой пришли клетки региона: при смене окна он на
      // мгновение ещё держит прежние
      var grid = meta.grid || 0.1, perRow = grid === 0.2 ? 1800 : 3600;
      for (var k = 0; k < r.blocks.length; k++) {
        var blk = r.blocks[k];
        for (var i = 0; i < blk.n && drawn < 30000; i++) {
          var key = blk.keys[i], lat = Math.floor(key / perRow) * grid - 90 + grid / 2;
          if (lat < south || lat > north) continue;
          var lon = (key % perRow) * grid - 180 + grid / 2;
          if (!wide) {
            var l = lon; while (l < west) l += 360; while (l > east) l -= 360;
            if (l < west) continue; lon = l;
          }
          // самый свежий шаг клетки, который уже наступил для момента просмотра
          var m = blk.masks[i], age = -1;
          for (var a = 0; a < steps; a++) {
            if (!(m & (1 << a))) continue;
            var t = (blk.latest - a) * step + step / 2;
            if (t <= tNow && tNow - t <= win) { age = (tNow - t) / win; break; }
          }
          if (age < 0) continue;
          var p1 = toCanvas([lat + grid / 2, lon - grid / 2]), p2 = toCanvas([lat - grid / 2, lon + grid / 2]);
          var w = Math.max(2, p2.x - p1.x), h = Math.max(2, p2.y - p1.y);
          ctx.fillStyle = rampCss(age, (0.3 + 0.45 * Math.min(1, blk.counts[i] / 14)) * (1 - 0.6 * age));
          ctx.fillRect(p1.x - 0.5, p1.y - 0.5, w + 1, h + 1);
          drawn++;
        }
      }
    });
  }

  function drawFlashes2D(ctx, size) {
    ['eu', 'am'].forEach(function (name) {
      var lv = live[name], cfg = LIVE[name], tNow = viewNow() - (view.scrub != null ? 0 : cfg.replay);
      for (var i = Math.max(0, lv.list.length - 3000); i < lv.list.length; i++) {
        var f = lv.list[i], age = tNow - f.t;
        if (age < 0 || age > cfg.win) continue;
        var p = toCanvas([f.lat, f.lon]);
        if (p.x < -10 || p.y < -10 || p.x > size.x + 10 || p.y > size.y + 10) continue;
        ctx.fillStyle = rampCss(age / cfg.win, 0.9 - 0.5 * age / cfg.win);
        ctx.beginPath(); ctx.arc(p.x, p.y, 2 + 2.5 * f.w, 0, 6.2832); ctx.fill();
      }
    });
  }

  /* Поверх точек: появление вспышки, движение грозы, моя точка, секундомер. */
  function drawFx(ctx, size, z) {
    var ink = skinName === 'light' ? '20,24,40' : '255,255,255';

    if (view.scrub == null && view.win === '1h') {
      var added = 0, b = map.getBounds(), am = live.am, tShow = now() - LIVE.am.replay;
      // Америки: вспыхивают те, чьё время показа наступило с прошлого кадра
      if (am.list.length) {
        var from = am.shownTo || (tShow - 2);
        for (var i = am.list.length - 1; i >= 0; i--) {
          var f = am.list[i];
          if (f.t <= from) break;
          if (f.t > tShow) continue;
          if (added < 40 && b.contains([f.lat, f.lon])) { pulses.push({ f: f, t0: performance.now() }); added++; thunder(f, z); }
        }
        am.shownTo = tShow;
      }
      // Европа: вспыхивает только что пришедшая пачка — её самые свежие разряды
      var fresh = live.eu.fresh;
      if (fresh.length) {
        live.eu.fresh = [];
        for (var q = fresh.length - 1; q >= 0 && added < 40; q--) {
          if (now() - fresh[q].t < 240 && b.contains([fresh[q].lat, fresh[q].lon])) { pulses.push({ f: fresh[q], t0: performance.now() }); added++; }
        }
      }
    }

    var nowMs = performance.now(), keep = [];
    for (var j = 0; j < pulses.length; j++) {
      var p = pulses[j], f2 = p.f, ms = nowMs - p.t0, pt = toCanvas([f2.lat, f2.lon]);
      // Круга грома здесь нет намеренно: вспышка попадает на карту минимум
      // через минуту после разряда, и звук к этому моменту уже ушёл за 25 км —
      // честно рисовать было бы нечего.
      var alive = ms < 900;
      if (alive) {
        var k = ms / 900;
        ctx.beginPath(); ctx.arc(pt.x, pt.y, 3 + k * 20, 0, 6.2832);
        ctx.strokeStyle = 'rgba(' + ink + ',' + (0.85 * (1 - k)) + ')'; ctx.lineWidth = 2; ctx.stroke();
        ctx.beginPath(); ctx.arc(pt.x, pt.y, 3.5 * (1 - k) + 1.5, 0, 6.2832);
        ctx.fillStyle = 'rgba(' + ink + ',' + (1 - k) + ')'; ctx.fill();
      }
      if (alive) keep.push(p);
    }
    pulses = keep;

    // Куда идёт гроза у «моей» точки: стрелка от ближайшего её края. Длина —
    // путь за полчаса, но не короче 44 px: у медленной грозы направление
    // иначе не прочесть. Двойной штрих — чтобы стрелку было видно и на
    // светлой подложке, и поверх красных клеток.
    if (me && motion && view.scrub == null) {
      var m0 = toCanvas([motion.at[0], motion.at[1]]);
      var kmPx = Math.abs(toCanvas([motion.at[0] + 10 / 111.2, motion.at[1]]).y - m0.y) / 10;
      var vAbs = Math.hypot(motion.vx, motion.vy) || 1, ux = motion.vx / vAbs, uy = -motion.vy / vAbs;
      var len = Math.max(44, vAbs * 30 * kmPx), ex = m0.x + ux * len, ey = m0.y + uy * len;
      var light = skinName === 'light', strokes = [[light ? 'rgba(255,255,255,.85)' : 'rgba(0,0,0,.6)', 6], [light ? '#1b2a6b' : '#ffffff', 2.5]];
      for (var si = 0; si < 2; si++) {
        ctx.strokeStyle = ctx.fillStyle = strokes[si][0]; ctx.lineWidth = strokes[si][1]; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath(); ctx.moveTo(m0.x, m0.y); ctx.lineTo(ex - ux * 8, ey - uy * 8); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(ex, ey);
        ctx.lineTo(ex - ux * 14 - uy * 7, ey - uy * 14 + ux * 7); ctx.lineTo(ex - ux * 14 + uy * 7, ey - uy * 14 - ux * 7);
        ctx.closePath(); ctx.fill(); if (si === 0) ctx.stroke();
      }
      ctx.lineCap = 'butt'; ctx.lineJoin = 'miter';
    }

    // Точки слежки: круг, внутри которого молнии дают сообщение.
    for (var wi = 0; wi < watches.length; wi++) {
      var wt = watches[wi], wp = toCanvas([wt.lat, wt.lng]);
      var wr = Math.abs(toCanvas([wt.lat + wt.radius_km / 111.2, wt.lng]).y - wp.y);
      if (wp.x < -wr || wp.y < -wr || wp.x > size.x + wr || wp.y > size.y + wr) continue;
      ctx.beginPath(); ctx.arc(wp.x, wp.y, wr, 0, 6.2832);
      ctx.setLineDash([2, 5]); ctx.strokeStyle = 'rgba(' + ink + ',.7)'; ctx.lineWidth = 1.5; ctx.stroke(); ctx.setLineDash([]);
      ctx.beginPath(); ctx.moveTo(wp.x, wp.y - 6); ctx.lineTo(wp.x + 6, wp.y); ctx.lineTo(wp.x, wp.y + 6); ctx.lineTo(wp.x - 6, wp.y); ctx.closePath();
      ctx.fillStyle = 'rgba(' + ink + ',.9)'; ctx.fill();
    }

    if (me) {
      var mp = toCanvas([me.lat, me.lon]);
      // круги 10 и 30 км — те же пороги, что в карточке «ваше место»
      [10, 30].forEach(function (km) {
        var e = toCanvas([me.lat + km / 111.2, me.lon]), rr = Math.abs(mp.y - e.y);
        if (rr < 14) return;
        ctx.beginPath(); ctx.arc(mp.x, mp.y, rr, 0, 6.2832);
        ctx.setLineDash([4, 5]); ctx.strokeStyle = 'rgba(122,167,255,.75)'; ctx.lineWidth = 1.2; ctx.stroke(); ctx.setLineDash([]);
        ctx.font = '600 12px system-ui,sans-serif'; ctx.fillStyle = 'rgba(122,167,255,.95)';
        ctx.fillText(km + ' ' + tr('km'), mp.x + 4, mp.y - rr - 4);
      });
      var tkm = timerRun ? (Date.now() - timerRun) / 1000 * SOUND_KMS : timerRingKm;
      if (tkm) {
        var te = toCanvas([me.lat + tkm / 111.2, me.lon]);
        ctx.beginPath(); ctx.arc(mp.x, mp.y, Math.abs(mp.y - te.y), 0, 6.2832);
        ctx.strokeStyle = 'rgba(255,214,90,.95)'; ctx.lineWidth = 2; ctx.stroke();
      }
      ctx.beginPath(); ctx.arc(mp.x, mp.y, 6, 0, 6.2832);
      ctx.fillStyle = '#7aa7ff'; ctx.fill(); ctx.lineWidth = 2; ctx.strokeStyle = '#fff'; ctx.stroke();
    }
  }

  /* Вуаль над местами, которые не видит ни один открытый спутник. */
  function drawCoverage(ctx, size) {
    var stepPx = 10, cols = Math.ceil(size.x / stepPx), rows = Math.ceil(size.y / stepPx);
    ctx.fillStyle = skinName === 'light' ? 'rgba(40,46,70,.30)' : 'rgba(8,10,20,.58)';
    for (var y = 0; y < rows; y++) {
      var run = -1;
      for (var x = 0; x <= cols; x++) {
        var none = false;
        if (x < cols) { var ll = map.unproject([drawn.org.x + x * stepPx + stepPx / 2, drawn.org.y + y * stepPx + stepPx / 2], drawn.zoom); none = coverageAt(ll.lat, ll.lng) === null; }
        if (none && run < 0) run = x;
        if (!none && run >= 0) { ctx.fillRect(run * stepPx, y * stepPx, (x - run) * stepPx, stepPx); run = -1; }
      }
    }
    var c = map.getCenter();
    if (coverageAt(c.lat, c.lng) === null) {
      ctx.font = '600 14px system-ui,sans-serif'; ctx.textAlign = 'center';
      ctx.fillStyle = skinName === 'light' ? 'rgba(20,24,40,.9)' : 'rgba(255,255,255,.92)';
      ctx.fillText(tr('cover_none'), size.x / 2, size.y / 2);
      ctx.textAlign = 'start';
    }
  }

  /* ── Что в кадре: какие регионы нужны ────────────────────────────────── */
  function onView() {
    var b = map.getBounds(), west = b.getWest(), east = b.getEast();
    var wantAm = false, wantEu = false;
    if (east - west >= 300) { wantAm = wantEu = true; } else {
      for (var i = 0; i <= 8; i++) {
        var lon = normLon(west + (east - west) * i / 8);
        if (lon < COVER.am.lonE + 5 || lon >= COVER.am.lonW - 5) wantAm = true;
        if (lon >= COVER.eu.lonW - 5 && lon <= COVER.eu.lonE + 5) wantEu = true;
      }
    }
    var changed = wantAm !== regions.am.want || wantEu !== regions.eu.want;
    regions.am.want = wantAm; regions.eu.want = wantEu;
    [['am', wantAm], ['eu', wantEu]].forEach(function (it) {
      var name = it[0];
      if (!it[1]) return;
      loadRegion(name);
      if (!live[name].timer) { live[name].timer = setInterval(function () { loadLive(name); }, LIVE[name].every); loadLive(name); }
    });
    if (changed) { renderStatus(); renderSoundHint(); }
    scheduleHot();
  }

  /* Вспышка «созрела» для показа, а кадров никто не просит (карта стоит) —
     будим отрисовку сами, иначе они копились бы до следующего движения. */
  function liveDue() {
    if (document.hidden || view.scrub != null || view.win !== '1h') return false;
    if (live.eu.fresh.length) return true;
    var am = live.am;
    if (!am.list.length) return false;
    var tShow = now() - LIVE.am.replay, from = am.shownTo || 0;
    for (var i = am.list.length - 1; i >= 0; i--) {
      var t = am.list[i].t;
      if (t <= from) return false;
      if (t <= tShow) return true;
    }
    return false;
  }

  /* Кусок клеток пришёл и разобран. Пустой ответ «кадров у региона нет вовсе»
     (meta.empty) — не данные: 13.10.2026 Европа десять часов отдавала именно
     его, а воронка каждой сессии честно писала «данные показаны». Завершение
     объявляет общий примитив: с голым событием стадия оставалась «data_shown»,
     и каждая удачная сессия при уходе записывалась брошенной. */
  function afterData(meta) {
    if (!afterData.done && !(meta && meta.empty)) {
      afterData.done = true; stage('data_shown');
      if (typeof window.__aeToolComplete === 'function') window.__aeToolComplete({}); else ae('tool_complete', { slug: SLUG });
    }
    schedule(); renderStatus(); renderMe(); renderHot();
  }

  /* ── Строка состояния: чему сколько времени ──────────────────────────── */
  function fmtAge(sec) {
    sec = Math.max(0, Math.round(sec));
    if (sec < 90) return sec + ' ' + tr('u_sec');
    if (sec < 5400) return Math.round(sec / 60) + ' ' + tr('u_min');
    return Math.round(sec / 3600) + ' ' + tr('u_hr');
  }
  function fmtClock(unix) {
    var d = new Date(unix * 1000);
    return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
  }

  /* Нужный региону кусок не грузится второй раз подряд. */
  function regionsFailing() {
    return ['am', 'eu'].some(function (n) { var r = regions[n]; return r.want && r.win !== view.win && (r.failed || 0) >= 2; });
  }

  function renderStatus() {
    var el = $('lmStatusText'), dot = $('lmDot'); if (!el) return;
    var c = map ? map.getCenter() : null, zone = c ? coverageAt(c.lat, c.lng) : null, bad = false, text;
    if (!statusData) {
      text = statusFailed ? tr('status_offline') : tr('status_loading'); bad = !!statusFailed;
    } else if (statusFailed >= 2 || regionsFailing()) {
      text = tr('status_offline'); bad = true;
    } else if (!zone && !(regions.am.want && regions.eu.want)) {
      text = tr('status_nodata'); bad = true;
    } else {
      var name = zone || (regions.am.want && !regions.eu.want ? 'am' : 'eu');
      var dt = regionDataTime(name);
      if (regionStale(name) || !dt) {
        text = tr('status_stale', { region: tr('region_' + name), time: dt ? fmtClock(dt) : '—' }); bad = true;
      } else {
        text = tr(name === 'eu' && euShowsFlashes() ? 'status_eu_live' : 'status_' + name, { age: fmtAge(now() - dt) });
      }
    }
    el.textContent = text;
    if (dot) dot.classList.toggle('stale', bad);
  }

  /* ── «Ваше место» ────────────────────────────────────────────────────── */
  function setMe(lat, lon, kind) {
    me = { lat: lat, lon: lon, kind: kind };
    timerRingKm = null; geoIssue = null;
    renderMe(); schedule();
    namePoint(me); loadWx(me);
    ae('feature_use', { slug: SLUG, feature: kind === 'geo' ? 'locate' : (kind === 'link' ? 'point_link' : 'pick_point') });
    // Блок слежки берёт точку отсюда: своей карты и своего поиска у него нет.
    try { document.dispatchEvent(new CustomEvent('lightning:me', { detail: { lat: lat, lon: lon, kind: kind } })); } catch (e) {}
  }

  /* Ссылка из сообщения слежки несёт точку в якоре (#p=55.75,37.62): якорь не
     доходит до сервера, и страница остаётся одной на всех в кэше. */
  function pointFromHash() {
    var m = /[#&]p=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/.exec(location.hash || '');
    if (!m) return null;
    var lat = parseFloat(m[1]), lon = parseFloat(m[2]);
    return (Math.abs(lat) <= 90 && Math.abs(lon) <= 180) ? { lat: lat, lon: lon } : null;
  }

  /* ── Имена мест — общий модуль GeoCity (public/js/geo-city.js) ──────────
   * Город с именем на языке страницы, поэтому подписи не выходят вперемешку
   * («Пуэрто-Аякучо · Camaguan · El Zulia»). Далёкий город (гроза над
   * джунглями или морем) подписью не становится — тогда называем страну; город
   * у границы идёт со СВОЕЙ страной («Кукута, Колумбия»). */
  function placeLabel(it, withCountry) {
    return window.GeoCity ? window.GeoCity.text(it, { country: withCountry }) : '';
  }
  function namePoint(point, again) {
    if (!window.GeoCity) return;
    window.GeoCity.lookup(point.lat, point.lon, { mode: 'near' }).then(function (it) {
      if (me !== point) return;
      if (!it) {
        // Сеть моргнула — одна повторная попытка; без имени карточка работает как прежде.
        if (!again) setTimeout(function () { if (me === point) namePoint(point, true); }, 6000);
        return;
      }
      point.place = placeLabel(it, false);
      if (!point.place) return;
      renderMe();
      // Блок слежки подставляет это имя точке по умолчанию.
      try { document.dispatchEvent(new CustomEvent('lightning:place', { detail: { lat: point.lat, lon: point.lon, name: point.place } })); } catch (e) {}
    });
  }

  /* ── Прогноз погоды для точки — из инструмента «Погода» ──────────────────
   * Тот же ответ, что получает страница погоды (/api/weather/forecast).
   * ⚠️ О грозе этот прогноз не говорит: замер 07.10.2026 по восьми местам от
   * Конго до Майами — ни одного «грозового» часа из 700, при том что над
   * частью из них спутник в эту минуту видел молнии. Поэтому отсюда берётся
   * только то, что прогноз знает: температура и будут ли осадки в ближайшие
   * часы. Для мест без спутниковых данных это единственная живая строка. */
  function loadWx(point) {
    if (!API.weather) return;
    var key = point.lat.toFixed(2) + ',' + point.lon.toFixed(2);
    if (wx && wx.key === key) return;
    wx = null;
    fetchTimed(API.weather + '?lat=' + point.lat.toFixed(2) + '&lon=' + point.lon.toFixed(2), 12000).then(function (r) { return r.json(); }).then(function (d) {
      if (me !== point) return;
      var got = readWx(d && d.hours, Date.now() / 1000);
      if (!got) return;
      got.key = key; wx = got;
      renderMe();
    }).catch(function () {});
  }
  /* Из почасового прогноза: температура сейчас и через сколько часов осадки
     (null — в ближайшие шесть часов их не ждут). Час считается «с осадками»,
     когда их показывает хотя бы половина моделей. */
  function readWx(hours, nowS) {
    if (!hours || !hours.length) return null;
    var cur = null, rainIn = null;
    for (var i = 0; i < hours.length; i++) {
      var h = hours[i], t = Date.parse(h.t) / 1000;
      if (isNaN(t) || t < nowS - 3600) continue;
      if (t > nowS + 6 * 3600) break;
      if (cur === null) cur = h;
      var wet = h.nvote ? (h.votes * 2 >= h.nvote && h.votes > 0) : (h.rain >= 0.2);
      if (wet && rainIn === null) rainIn = Math.max(0, Math.round((t - nowS) / 3600));
    }
    if (!cur || typeof cur.temp !== 'number') return null;
    return { temp: Math.round(cur.temp), rainIn: rainIn };
  }
  function wxRow() {
    if (!me || !wx || wx.key !== me.lat.toFixed(2) + ',' + me.lon.toFixed(2)) return '';
    var rain = wx.rainIn === null ? tr('wx_dry') : (wx.rainIn < 1 ? tr('wx_rain_now') : tr('wx_rain_in', { h: wx.rainIn }));
    var h = '<p class="lm-me-wx">' + esc(tr('wx_line', { temp: (wx.temp > 0 ? '+' : '') + wx.temp, rain: rain }));
    var W = C.weather || {};
    if (W.url) {
      var href = W.url + '?lat=' + me.lat.toFixed(4) + '&lon=' + me.lon.toFixed(4) + (me.place ? '&place=' + encodeURIComponent(me.place) : '');
      h += ' <a href="' + esc(href) + '">' + esc(W.title || '') + ' →</a>';
    }
    return h + '</p>';
  }

  /* Расстояние до ближайшей активной клетки по каждому шагу окна. */
  function nearestBySteps(name) {
    var r = regions[name], meta = r.meta || {}, steps = meta.steps || 12, grid = meta.grid || 0.1;
    if (!r.win) return null;
    var d = [], who = [], a, cosLat = Math.cos(me.lat * Math.PI / 180) || 0.01;
    for (a = 0; a < steps; a++) { d.push(Infinity); who.push(null); }
    eachCellNear(r, me.lat, me.lon, 3, 3 / cosLat, function (blk, i, lat, lon) {
      var dLat = lat - me.lat; if (dLat > 3 || dLat < -3) return;
      var dLon = lon - me.lon;
      if (dLon > 180) dLon -= 360; else if (dLon < -180) dLon += 360;
      if (dLon * cosLat > 3 || dLon * cosLat < -3) return;
      var km = Math.sqrt(dLat * dLat + dLon * dLon * cosLat * cosLat) * 111.2, m = blk.masks[i];
      // шаг клетки → возраст от САМОГО свежего кадра региона
      var shift = (r.newest || blk.latest) - blk.latest;
      for (var a2 = 0; a2 + shift < steps; a2++) {
        if ((m & (1 << a2)) && km < d[a2 + shift]) { d[a2 + shift] = km; who[a2 + shift] = [lat, lon]; }
      }
    });
    return { d: d, who: who, step: meta.step || 300 };
  }

  function analyseMe() {
    var zone = coverageAt(me.lat, me.lon);
    if (!zone) return { state: 'nodata' };
    var r = regions[zone];
    if (!r.want) { r.want = true; loadRegion(zone); }
    if (!statusData || statusFailed >= 2 || regionStale(zone)) return { state: 'stale', zone: zone, time: regionDataTime(zone) };
    if (!r.win || r.win !== view.win || !r.meta) return (r.failed || 0) >= 2 ? { state: 'stale', zone: zone, time: regionDataTime(zone) } : { state: 'wait' };
    r.newest = 0; for (var b = 0; b < r.blocks.length; b++) r.newest = Math.max(r.newest, r.blocks[b].latest);
    var nb = nearestBySteps(zone); if (!nb) return { state: 'wait' };
    // «сейчас» — два свежих кадра часа; в суточном окне шаг и так час
    var d = nb.d, stepMin = nb.step / 60, hourly = r.win === '1h';
    var recent = hourly ? Math.min(d[0], d[1]) : d[0], at = (!hourly || d[0] <= d[1]) ? nb.who[0] : nb.who[1];
    var lastAge = -1, lastKm = Infinity, lastWho = null;
    for (var a = 0; a < d.length; a++) if (d[a] < 100) { lastAge = a; lastKm = d[a]; lastWho = nb.who[a]; break; }
    // отдельные вспышки уточняют «сейчас» там, где они есть
    var lv = live[zone], tShow = now() - LIVE[zone].replay;
    for (var i = lv.list.length - 1; i >= 0; i--) {
      var f = lv.list[i]; if (f.t > tShow || tShow - f.t > 600) continue;
      var dla = f.lat - me.lat; if (dla > 1 || dla < -1) continue;
      var km = kmBetween(me.lat, me.lon, f.lat, f.lon);
      if (km < recent) { recent = km; at = [f.lat, f.lon]; }
    }
    var out = { state: 'ok', zone: zone, edge: edgeAt(me.lat, me.lon), dataAge: now() - regionDataTime(zone) };
    if (recent < 100) {
      out.km = recent; out.dir = bearing8(me.lat, me.lon, at[0], at[1]);
      out.level = recent <= 10 ? 3 : (recent <= 30 ? 2 : 1);
      var mv = hourly ? stormMotion(zone, at) : null;
      if (mv) {
        out.move = mv;
        var path = approach(mv, recent);
        out.near = path.near; if (path.eta != null) out.eta = path.eta; if (path.miss != null) out.miss = path.miss;
      }
    } else {
      out.level = 0;
      if (lastAge >= 0) {
        // «сколько минут назад» — от настоящего момента, а не от свежего кадра
        var pastT = (r.newest - lastAge) * nb.step + nb.step / 2;
        out.pastKm = lastKm; out.pastMin = Math.max(1, Math.round((now() - pastT) / 60)); out.pastDir = bearing8(me.lat, me.lon, lastWho[0], lastWho[1]);
      }
    }
    return out;
  }

  /* Куда и как быстро идёт гроза вокруг точки `at`.
   *
   * По каждому из семи последних кадров (полчаса) берём центр тяжести клеток в
   * 120 км от `at` и проводим через центры прямую по времени — её наклон и есть
   * скорость. Центр, а не край: край очага дрожит от кадра к кадру, и прежняя
   * оценка «по ближайшей клетке» принимала рост грозы за её движение.
   * null — данных мало (меньше трёх кадров или десяти минут) либо получилось
   * неправдоподобно быстро: тогда про движение молчим. */
  function stormMotion(zone, at) { return stormMotionOf(regions[zone], at, now()); }
  function stormMotionOf(r, at, tNow) {
    var meta = r.meta || {}, grid = meta.grid || 0.1, step = meta.step || 300, steps = Math.min(7, meta.steps || 12);
    var cosAt = Math.cos(at[0] * Math.PI / 180) || 0.01, sum = [], a;
    for (a = 0; a < steps; a++) sum.push({ w: 0, x: 0, y: 0, n: 0 });
    var latest = [], reach = 120 / 111.2 + grid;
    eachCellNear(r, at[0], at[1], reach, reach / cosAt, function (blk, i, lat, lon) {
      var shift = (r.newest || blk.latest) - blk.latest;
      var dy = (lat - at[0]) * 111.2; if (dy > 120 || dy < -120) return;
      var dLon = lon - at[1];
      if (dLon > 180) dLon -= 360; else if (dLon < -180) dLon += 360;
      var dx = dLon * 111.2 * cosAt; if (dx * dx + dy * dy > 14400) return;
      var m = blk.masks[i], w = blk.counts[i], isNew = false;
      for (var a2 = 0; a2 + shift < steps; a2++) {
        if (!(m & (1 << a2))) continue;
        var sm = sum[a2 + shift]; sm.w += w; sm.x += dx * w; sm.y += dy * w; sm.n++;
        if (a2 + shift <= 1) isNew = true;
      }
      if (isNew) latest.push([dx, dy]);
    });
    var pts = [];
    for (a = 0; a < steps; a++) if (sum[a].n >= 3) pts.push({ t: -a * step / 60, x: sum[a].x / sum[a].w, y: sum[a].y / sum[a].w, w: Math.sqrt(sum[a].n) });
    if (pts.length < 3 || pts[0].t - pts[pts.length - 1].t < 10) return null;
    var sw = 0, st = 0, sx = 0, sy = 0, stt = 0, stx = 0, sty = 0;
    pts.forEach(function (p) { sw += p.w; st += p.w * p.t; sx += p.w * p.x; sy += p.w * p.y; stt += p.w * p.t * p.t; stx += p.w * p.t * p.x; sty += p.w * p.t * p.y; });
    var den = sw * stt - st * st; if (!den) return null;
    var vx = (sw * stx - st * sx) / den, vy = (sw * sty - st * sy) / den;      // км в минуту
    var kmh = Math.hypot(vx, vy) * 60;
    if (kmh > 130) return null;
    // Свежему кадру уже несколько минут (над Европой — до двенадцати), и гроза
    // за это время прошла дальше: стрелка и время прихода считаются от «сейчас».
    var lag = Math.max(0, Math.min(20, (tNow - ((r.newest || 0) + 0.5) * step) / 60));
    return {
      vx: vx, vy: vy, kmh: kmh, dir: Math.round(((Math.atan2(vx, vy) * 180 / Math.PI + 360) % 360) / 45) % 8,
      cells: latest, at: at, cosAt: cosAt, lag: lag
    };
  }

  /* Что этот курс значит для «моей» точки: подходит ли гроза, когда её край
     окажется в 10 км и насколько близко она пройдёт, если пройдёт стороной. */
  function approach(mv, nowKm) { return approachOf(mv, me, nowKm); }
  function approachOf(mv, pt, nowKm) {
    var out = { near: 'out' };
    if (mv.kmh < 8) { out.near = 'still'; return out; }
    // точка в координатах стрелки (км от `at`)
    var mx = (pt.lon - mv.at[1]) * 111.2 * mv.cosAt, my = (pt.lat - mv.at[0]) * 111.2;
    var v2 = mv.vx * mv.vx + mv.vy * mv.vy, eta = Infinity, miss = Infinity, R = 10;
    for (var i = 0; i < mv.cells.length; i++) {
      var rx = mv.cells[i][0] + mv.vx * mv.lag - mx, ry = mv.cells[i][1] + mv.vy * mv.lag - my, dot = rx * mv.vx + ry * mv.vy;
      if (dot >= 0) continue;                                   // эта клетка от точки уходит
      var tStar = -dot / v2, dmin = Math.hypot(rx + mv.vx * tStar, ry + mv.vy * tStar);
      if (dmin < miss) miss = dmin;
      var c = rx * rx + ry * ry - R * R, disc = dot * dot - v2 * c;
      if (disc >= 0) { var t1 = (-dot - Math.sqrt(disc)) / v2; if (t1 < eta) eta = Math.max(0, t1); }
    }
    if (miss < nowKm - 3) out.near = 'in';
    if (nowKm > R && eta > 3 && eta <= 180) out.eta = eta;
    else if (out.near === 'in' && eta === Infinity && miss >= 12 && miss <= 80) out.miss = miss;
    return out;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderMe() {
    var box = $('lmMe'); if (!box) return;
    if (!me) {
      motion = null;
      // «Рядом со мной» не сработало: причина и шаги — здесь же, в карточке,
      // и стоят, пока человек не вернёт доступ или не выберет точку на карте.
      if (geoIssue) {
        box.setAttribute('data-level', 'unknown');
        var g = '<div class="lm-me-head">' + esc(geoIssue.title) + '</div><p class="lm-me-text">' + esc(geoIssue.message) + '</p>';
        if (geoIssue.steps && geoIssue.steps.length) g += '<ol class="lm-me-steps">' + geoIssue.steps.map(function (st) { return '<li>' + esc(st) + '</li>'; }).join('') + '</ol>';
        $('lmMeBody').innerHTML = g + '<p class="lm-me-caveat">' + esc(tr('me_prompt')) + '</p>';
        return;
      }
      box.setAttribute('data-level', 'none'); $('lmMeBody').innerHTML = '<p class="lm-me-prompt">' + esc(tr('me_prompt')) + '</p>'; return;
    }
    var a = analyseMe(), h = '', title = tr(me.kind === 'geo' ? 'me_title_geo' : 'me_title_pick') + (me.place ? ' · ' + me.place : '');
    if (a.state === 'nodata') {
      box.setAttribute('data-level', 'unknown');
      h = '<div class="lm-me-head">' + esc(tr('me_nodata_title')) + '</div><p class="lm-me-text">' + esc(tr('me_nodata_text')) + '</p>';
    } else if (a.state === 'stale') {
      box.setAttribute('data-level', 'unknown');
      h = '<div class="lm-me-head">' + esc(tr('me_unknown_title')) + '</div><p class="lm-me-text">' + esc(tr('me_stale', { time: a.time ? fmtClock(a.time) : '—' })) + '</p>';
    } else if (a.state === 'wait') {
      box.setAttribute('data-level', 'none');
      h = '<p class="lm-me-prompt">' + esc(tr('loading')) + '</p>';
    } else {
      box.setAttribute('data-level', String(a.level));
      h = '<div class="lm-me-head">' + esc(tr('me_lvl' + a.level)) + '</div>';
      if (a.level > 0) {
        h += '<div class="lm-me-big"><b>' + (a.km < 10 ? a.km.toFixed(1) : Math.round(a.km)) + '</b> ' + esc(tr('km')) + ' <span>' + esc(tr('dir_' + a.dir)) + '</span></div>';
        if (a.move) {
          // Гроза уже над точкой (ближе 10 км) — «приближается» и «удаляется»
          // тут ничего не добавляют: край очага дрожит на эти же километры.
          var moving = a.near === 'still' ? tr('me_move_still')
            : tr('me_move', { dir: tr('mv_' + a.move.dir), v: Math.max(10, Math.round(a.move.kmh / 5) * 5) })
              + (a.km > 10 ? ', ' + tr(a.near === 'in' ? 'me_near_in' : 'me_near_out') : '');
          h += '<div class="lm-me-row"><span>' + esc(tr('me_trend')) + '</span><b>' + esc(moving) + '</b></div>';
        }
        if (a.eta != null) {
          // оценка, а не расписание: показываем вилку, округлённую до пяти минут
          var lo = Math.max(5, Math.floor(a.eta * 0.75 / 5) * 5), hi = Math.max(lo + 5, Math.ceil(a.eta * 1.3 / 5) * 5);
          h += '<div class="lm-me-row"><span>' + esc(tr('me_eta')) + '</span><b>' + lo + '–' + hi + ' ' + esc(tr('u_min')) + '</b></div>';
        } else if (a.miss != null) {
          h += '<p class="lm-me-text">' + esc(tr('me_miss', { km: Math.round(a.miss / 5) * 5 })) + '</p>';
        }
      } else if (a.pastKm != null) {
        h += '<p class="lm-me-text">' + esc(tr('me_past', { km: Math.round(a.pastKm), dir: tr('dir_' + a.pastDir), min: a.pastMin })) + '</p>';
      }
      h += '<p class="lm-me-text">' + esc(tr('me_lvl' + a.level + '_tip')) + '</p>';
      h += '<p class="lm-me-caveat">' + esc(tr('me_caveat_' + a.zone + (a.edge ? '_edge' : ''), { age: fmtAge(a.dataAge) })) + (a.eta != null || a.miss != null ? ' ' + esc(tr('me_eta_note')) : '') + '</p>';
    }
    motion = a.state === 'ok' && a.move && a.near !== 'still' ? a.move : null;
    $('lmMeBody').innerHTML = '<div class="lm-me-kicker">' + esc(title) + '</div>' + h + wxRow();
    // Экранному диктору — только смена самого ответа (уровень или десяток
    // километров), а не тикающий возраст данных.
    var say = a.state + ':' + (a.level != null ? a.level : '') + ':' + (a.km != null ? Math.round(a.km / 10) : '');
    if (say !== lastSaid) {
      lastSaid = say;
      var head = box.querySelector('.lm-me-head'), big = box.querySelector('.lm-me-big');
      if (head && window.__announce) window.__announce(head.textContent + (big ? '. ' + big.textContent : ''));
    }
  }

  /* ── «Где гремит сейчас»: грозы в поле карты ─────────────────────────────
   * Список называет то, что человек видит на карте: до пяти самых активных
   * мест в её границах; подвинул карту — список идёт за ней. Прежний брал пять
   * самых активных мест всего региона, а регион «Европа и Африка» — это всегда
   * Конго и Ангола: читателю, который смотрит на Европу, список предлагал
   * тропики (первая неделя: два нажатия на 391 сессию). В поле карты тихо —
   * тогда самые активные места за его пределами: по списку туда и летят.
   *
   * «Сейчас» — два свежих кадра клеток (в суточном окне — свежий час) и
   * отдельные вспышки не старше десяти минут. Кадр источника, который замолчал,
   * о «сейчас» не говорит (тот же срок, что у слежки: LightningFeed). */
  var HOT_FRAME_FRESH = 1500, HOT_FLASH_FRESH = 600, HOT_MAX = 5;
  function inBox(v, lat, lon) {
    if (lat < v.south || lat > v.north) return false;
    if (v.east - v.west >= 360) return true;
    var l = lon; while (l < v.west) l += 360; while (l > v.east) l -= 360;
    return l >= v.west;
  }
  function hotSpots(regs, lives, view, tNow) {
    // сторона ведра: чем ближе карта, тем мельче делится гроза на места
    var per = view && view.zoom >= 7 ? 0.5 : (view && view.zoom >= 5 ? 1 : 3);
    var near = {}, far = {};
    function put(lat, lon, w) {
      var inside = !!view && inBox(view, lat, lon), set = inside ? near : far, size = inside ? per : 3;
      var bk = Math.floor((lat + 90) / size) * 100000 + Math.floor((lon + 180) / size);
      var o = set[bk] || (set[bk] = { n: 0, lat: 0, lon: 0 });
      o.n += w; o.lat += lat * w; o.lon += lon * w;
    }
    ['eu', 'am'].forEach(function (name) {
      var r = regs[name]; if (!r || !r.want) return;
      if (r.win && r.meta) {
        var grid = r.meta.grid || 0.1, step = r.meta.step || 300, perRow = grid === 0.2 ? 1800 : 3600, fresh = r.win === '24h' ? 1 : 3;
        for (var k = 0; k < r.blocks.length; k++) {
          var blk = r.blocks[k];
          if (tNow - (blk.latest + 1) * step > HOT_FRAME_FRESH) continue;
          for (var i = 0; i < blk.n; i++) {
            if (!(blk.masks[i] & fresh)) continue;
            var key = blk.keys[i];
            put(Math.floor(key / perRow) * grid - 90 + grid / 2, (key % perRow) * grid - 180 + grid / 2, blk.counts[i]);
          }
        }
      }
      var lv = lives[name], tShow = tNow - LIVE[name].replay;
      for (var j = lv ? lv.list.length - 1 : -1; j >= 0; j--) {      // список — по времени, свежие в конце
        var f = lv.list[j];
        if (tShow - f.t > HOT_FLASH_FRESH) break;
        if (f.t <= tShow) put(f.lat, f.lon, 1);
      }
    });
    var list = [], src = near, b;
    for (b in near) { list.push(near[b]); }
    if (!list.length) { src = far; for (b in far) list.push(far[b]); }
    list.sort(function (x, y) { return y.n - x.n; });
    return list.slice(0, HOT_MAX).map(function (o) {
      var lat = o.lat / o.n, lon = o.lon / o.n;
      // Имя спрашивается по точке, округлённой до полуградуса: центр грозы
      // сдвигается каждый кадр, а округлённый адрес сервер и страница уже помнят.
      return { lat: lat, lon: lon, inView: src === near, ask: { lat: Math.round(lat * 2) / 2, lon: Math.round(lon * 2) / 2 } };
    });
  }

  var hotTimer = 0;
  function scheduleHot() { clearTimeout(hotTimer); hotTimer = setTimeout(renderHot, 250); }

  function renderHot() {
    var host = $('lmHot'); if (!host) return;
    var vb = map ? map.getBounds() : null;
    var spots = hotSpots(regions, live, vb ? { south: vb.getSouth(), north: vb.getNorth(), west: vb.getWest(), east: vb.getEast(), zoom: map.getZoom() } : null, now());
    if (!spots.length) { ++hotSeq; host.innerHTML = (regions.am.win || regions.eu.win) ? '<span class="lm-hot-none">' + esc(tr('hot_none')) + '</span>' : ''; return; }
    var seq = ++hotSeq;
    var named = [];
    var paint = function () {
      if (seq !== hotSeq) return;
      var seen = {}, html = '', shown = [];
      spots.forEach(function (sp, k) {
        var name = placeLabel(named[k], true) || (sp.lat.toFixed(1) + '°, ' + sp.lon.toFixed(1) + '°');
        if (seen[name]) return;                              // две грозы у одного города — одна кнопка
        seen[name] = 1; shown.push(sp);
        html += '<button type="button" class="lm-chip" data-i="' + (shown.length - 1) + '"><span aria-hidden="true">⚡</span> <span class="lm-chip-t">' + esc(name) + '</span></button>';
      });
      host.innerHTML = html;
      shown.forEach(function (sp, i) {
        host.querySelector('[data-i="' + i + '"]').onclick = function () { map.flyTo([sp.lat, sp.lon], Math.max(map.getZoom(), 6)); ae('feature_use', { slug: SLUG, feature: 'hot_jump', view: sp.inView ? 1 : 0 }); };
      });
    };
    // Кнопки появляются уже с именами: прежние стоят, пока не пришли новые.
    if (!window.GeoCity) { paint(); return; }
    window.GeoCity.lookupMany(spots.map(function (sp) { return sp.ask; }), { mode: 'area' }).then(function (items) { named = items; paint(); });
  }

  /* ── Окно, проигрывание, слои ────────────────────────────────────────── */
  function setWindow(win) {
    if (view.win === win) return;
    view.win = win; stopPlayback(true);
    document.querySelectorAll('#lmWin button').forEach(function (b) {
      var on = b.getAttribute('data-win') === win;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    ['am', 'eu'].forEach(function (n) { if (regions[n].want) loadRegion(n, true); });
    paintLegend(); renderScrub(); schedule();
    ae('feature_use', { slug: SLUG, feature: 'window', win: win });
  }

  var playT0 = 0;
  function stepPlayback() {
    var k = (performance.now() - playT0) / 12000;
    if (k >= 1) { stopPlayback(true); return; }
    view.scrub = now() - winSec() * (1 - k);
    var s = $('lmScrub'); if (s) s.value = Math.round(k * 1000);
    renderScrub();
  }
  function stopPlayback(toNow) {
    view.playing = false;
    if (toNow) { view.scrub = null; var s = $('lmScrub'); if (s) s.value = 1000; }
    var b = $('lmPlay'); if (b) { b.setAttribute('aria-pressed', 'false'); b.textContent = '▶ ' + tr('play'); }
    renderScrub(); schedule();
  }
  function renderScrub() {
    var el = $('lmScrubLabel'); if (!el) return;
    if (view.scrub == null) { el.textContent = tr('now'); return; }
    el.textContent = '−' + fmtAge(now() - view.scrub);
  }

  function paintLegend() {
    var bar = $('lmLegendBar'); if (!bar) return;
    var stops = RAMP[skinName].map(function (s) { return 'rgb(' + s[1] + ',' + s[2] + ',' + s[3] + ') ' + Math.round(s[0] * 100) + '%'; });
    bar.style.background = 'linear-gradient(90deg,' + stops.join(',') + ')';
    var old = $('lmLegendOld'); if (old) old.textContent = tr(view.win === '24h' ? 'legend_old_24h' : 'legend_old_1h');
  }

  function renderSoundHint() {
    var el = $('lmSoundHint'); if (!el) return;
    el.hidden = !(view.sound && !regions.am.want);
  }

  /* Гром: короткий шум через фильтр низких частот. Звучит только для вспышек
     в кадре и не чаще раза в 0,4 с — иначе тропический шторм даёт стену шума. */
  function thunder(f, z) {
    if (!view.sound || !audio || z < 4) return;
    var t = performance.now(); if (t - lastThunder < 400) return; lastThunder = t;
    try {
      var ctx = audio, dur = 1.6, n = Math.floor(ctx.sampleRate * dur), buf = ctx.createBuffer(1, n, ctx.sampleRate), d = buf.getChannelData(0), v = 0;
      for (var i = 0; i < n; i++) { v = v * 0.985 + (Math.random() * 2 - 1) * 0.15; d[i] = v * Math.pow(1 - i / n, 2.2); }
      var src = ctx.createBufferSource(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      src.buffer = buf; lp.type = 'lowpass'; lp.frequency.value = 260 + 500 * f.w; g.gain.value = 0.25 + 0.5 * f.w;
      src.connect(lp); lp.connect(g); g.connect(ctx.destination); src.start();
    } catch (e) {}
  }

  function toggleSound(on) {
    view.sound = on; renderSoundHint();
    if (!on) return;
    var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
    var make = function () { return new AC(); };
    var ready = window.__liveAudioCtxReady ? window.__liveAudioCtxReady(audio, make) : Promise.resolve(audio || make());
    ready.then(function (ctx) { audio = ctx; }).catch(function () { view.sound = false; var c = $('lmSound'); if (c) c.checked = false; });
  }

  /* ── Секундомер грома ────────────────────────────────────────────────── */
  function timerTick() {
    if (!timerRun) return;
    var s = (Date.now() - timerRun) / 1000;
    $('lmTimerOut').textContent = tr('timer_run', { s: s.toFixed(1) });
    if (s > 90) { timerStop(true); return; }
    setTimeout(timerTick, 100);
  }
  function timerStop(timeout) {
    if (!timerRun) return;
    var s = (Date.now() - timerRun) / 1000; timerRun = null;
    var btn = $('lmTimerBtn'); btn.textContent = tr('timer_start'); btn.classList.remove('run');
    if (timeout) { $('lmTimerOut').textContent = tr('timer_far'); timerRingKm = null; schedule(); return; }
    var km = s * SOUND_KMS;
    timerRingKm = km;
    $('lmTimerOut').textContent = tr('timer_result', { km: km < 10 ? km.toFixed(1) : Math.round(km), s: s.toFixed(1) });
    schedule();
    ae('feature_use', { slug: SLUG, feature: 'thunder_timer' });
  }
  function timerPress() {
    if (timerRun) { timerStop(false); return; }
    timerRun = Date.now(); timerRingKm = null;
    var btn = $('lmTimerBtn'); btn.textContent = tr('timer_stop'); btn.classList.add('run');
    timerTick(); schedule();
  }

  /* ── На весь экран ───────────────────────────────────────────────────────
   * Экран получает консоль ЦЕЛИКОМ — карта, полоса времени и рейка с ответом:
   * отдельного «режима карты» со своим набором кнопок нет, человек видит то же
   * самое, только карта берёт всю высоту. Дверь сайта `__wholeScreen`: где
   * браузер не отдаёт экран элементу (iPhone), консоль встаёт наложением на
   * всё окно. Раскладка — `.lm.tmb-whole`; вход считает сама дверь. */
  function initFullscreen() {
    var btn = $('lmFull'), app = $('lmApp');
    if (!btn || !app || typeof window.__wholeScreen !== 'function') return;
    var screen = window.__wholeScreen(app, { key: SLUG, onChange: function (on) {
      var label = tr(on ? 'fullscreen_exit' : 'fullscreen');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.title = label; btn.setAttribute('aria-label', label);
    } });
    btn.hidden = false;
    btn.addEventListener('click', function () { screen.toggle(); });
  }

  /* ── Запуск ──────────────────────────────────────────────────────────── */
  function locate() {
    var b = $('lmLocate');
    if (!window.__geo) return;
    if (b) b.disabled = true;
    window.__geo.get({ enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }).then(function (pos) {
      if (b) b.disabled = false;
      setMe(pos.coords.latitude, pos.coords.longitude, 'geo');
      map.flyTo([me.lat, me.lon], Math.max(map.getZoom(), 7));
    }).catch(function (err) {
      if (b) b.disabled = false;
      geoIssue = window.__geo.explain ? window.__geo.explain(err) : null;
      if (!geoIssue) { if (window.__geo.notify) window.__geo.notify(err); return; }
      renderMe();
      if (window.__announce) window.__announce(geoIssue.title);
      var card = $('lmMe'); if (card && card.scrollIntoView) card.scrollIntoView({ block: 'nearest' });
      // Человек уйдёт в настройки браузера; вернёт доступ — доделаем сами.
      if (!locate.healing && window.__geo.onRecover) {
        locate.healing = window.__geo.onRecover(function () { locate.healing = null; if (!me) locate(); });
      }
    });
  }

  function boot() {
    if (!initMap()) return;
    stage('map_ready');
    paintLegend(); renderMe(); renderScrub();
    var linked = pointFromHash();
    if (linked) { map.setView([linked.lat, linked.lon], 8, { animate: false }); setMe(linked.lat, linked.lon, 'link'); }
    onView(); loadStatus();
    setInterval(loadStatus, 20000);
    // возраст данных в строке состояния и цвета точек стареют сами — раз в 5 с
    setInterval(function () { if (!document.hidden) { renderStatus(); if (view.scrub == null) schedule(); } }, 5000);
    setInterval(function () { if (!document.hidden && me) renderMe(); }, 30000);
    setInterval(function () { if (liveDue()) schedule(); }, 250);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { loadStatus(); loadLive('am'); loadLive('eu'); schedule(); } });

    var lb = $('lmLocate'); if (lb) lb.addEventListener('click', locate);
    document.querySelectorAll('#lmWin button').forEach(function (btn) {
      btn.addEventListener('click', function () { setWindow(btn.getAttribute('data-win')); });
    });
    var play = $('lmPlay');
    if (play) play.addEventListener('click', function () {
      if (view.playing) { stopPlayback(false); return; }
      view.playing = true; playT0 = performance.now(); play.setAttribute('aria-pressed', 'true'); play.textContent = '❚❚ ' + tr('pause');
      ae('feature_use', { slug: SLUG, feature: 'playback' }); schedule();
    });
    var scrub = $('lmScrub');
    if (scrub) scrub.addEventListener('input', function () {
      view.playing = false; var b = $('lmPlay'); if (b) { b.setAttribute('aria-pressed', 'false'); b.textContent = '▶ ' + tr('play'); }
      var k = scrub.value / 1000; view.scrub = k >= 0.999 ? null : now() - winSec() * (1 - k);
      renderScrub(); schedule();
    });
    var cover = $('lmCover');
    if (cover) cover.addEventListener('change', function () { view.cover = cover.checked; schedule(); ae('feature_use', { slug: SLUG, feature: 'coverage', on: view.cover }); });
    var sound = $('lmSound');
    if (sound) sound.addEventListener('change', function () { toggleSound(sound.checked); ae('feature_use', { slug: SLUG, feature: 'sound', on: sound.checked }); });
    var tb = $('lmTimerBtn'); if (tb) tb.addEventListener('click', timerPress);
    initFullscreen();
  }

  // Крючки для стендов: состояние читается, а не угадывается по пикселям.
  window.__lightningMap = {
    state: function () {
      return { win: view.win, cells: { am: regions.am.n, eu: regions.eu.n }, flashes: { am: live.am.n, eu: live.eu.n }, gl: !!gl, me: me, status: statusData, want: { am: regions.am.want, eu: regions.eu.want } };
    },
    coverageAt: coverageAt,
    edgeAt: edgeAt,
    parse: { payload: parsePayload, cells: parseCells, live: parseLive },
    map: function () { return map; },
    me: function () { return me; },
    setMe: function (lat, lon) { setMe(lat, lon, 'pick'); },
    // для блока слежки: показать точку из списка и нарисовать круги
    focus: function (lat, lon) { if (!map) return; setMe(lat, lon, 'pick'); map.flyTo([lat, lon], Math.max(map.getZoom(), 8)); },
    setWatches: function (list) { watches = Array.isArray(list) ? list : []; if (map) schedule(); },
    analyse: function () { return me ? analyseMe() : null; },
    // чему соответствует нарисованное — для стенда «слой не расходится с подложкой»
    layer: function () { return drawn ? { min: { x: drawn.min.x, y: drawn.min.y }, w: drawn.w, h: drawn.h, zoom: drawn.zoom, org: { x: drawn.org.x, y: drawn.org.y }, canvas: glc } : null; },
    // чистые расчёты — для стендов
    readWx: readWx,
    hotOf: hotSpots,
    indexOf: indexRegion,
    motionOf: stormMotionOf,
    approachOf: approachOf
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
